/* Courted · entry for /courted/ (T4). The same module the app shell loads, in a phone-width column under its own
   header. Courted is drawn in the redesign only, so the page always is: the design system's components (scoped
   under html[data-redesign], as in the shell), Courted's styles scoped to its pane, and Appearance. */
import '../ui/components.css?dv-scope=redesign';
import './styles/redesign.css?dv-scope=courted';
import './styles/anim.css?dv-scope=courted';
import './styles/web.css';
import { applyTheme, watchTheme } from '../core/theme.js';
import { mount } from './module.js';

applyTheme();
watchTheme();
mount(document.getElementById('root'));
